import { render, staticRenderFns } from "./outOfStockOrder.vue?vue&type=template&id=40107a9e&scoped=true"
import script from "./outOfStockOrder.vue?vue&type=script&lang=js"
export * from "./outOfStockOrder.vue?vue&type=script&lang=js"
import style0 from "./outOfStockOrder.vue?vue&type=style&index=0&id=40107a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40107a9e",
  null
  
)

export default component.exports